type EncodedFile = {
  file: string
  filename: string
}

const readFile = (file?: {
  name?: string
  fileName?: string
}): Promise<void | EncodedFile> => {
  const filename = file?.name || file?.fileName
  if (!filename) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result
      if (typeof result !== "string") {
        reject(reader.error || new Error("File could not be read"))
        return
      }

      // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
      const b64 = result.replace(/^data:.+;base64,/, "")
      resolve({ file: b64, filename })
    }
    reader.readAsDataURL(file as Blob)
  })
}

export default readFile
